import { computed, ref, watch } from 'vue'

import { useUpdateAccountEmailMutation } from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

export function useChangeEmail() {
  const toastStore = useToastStore()
  const webviewStore = useWebviewStore()

  const { mutate: updateEmail, loading } = useUpdateAccountEmailMutation()

  const newEmail = ref('')
  const confirmEmail = ref('')
  const error = ref('')

  const canSave = computed(
    () => !!newEmail.value.trim() && !!confirmEmail.value.trim()
  )

  watch([newEmail, confirmEmail], () => {
    error.value = ''
  })

  const save = async () => {
    if (!canSave.value) return false

    if (newEmail.value !== confirmEmail.value) {
      error.value = 'Email does not match.'
      return false
    }

    try {
      await updateEmail({ newEmail: newEmail.value })

      if (webviewStore.isActive) {
        webviewStore.postMessage({ type: NativeActionsEnum.UserUpdated })
      }

      toastStore.showToast({
        type: ToastType.Success,
        content: 'Your email has been updated',
      })

      return true
    } catch (err) {
      console.error(err)
      error.value = (err as Error).message
      return false
    }
  }

  return { newEmail, confirmEmail, error, loading, canSave, save }
}
